export enum ESubcampaignsFilters {
  Origin = 'origin',
  Destination = 'destination'
}
export interface IFilterPlace {
  id?: string
  name: string
}
export interface ISubcampaignsFilters {
  origin: IFilterPlace
  destination: IFilterPlace
}
export interface ISubcampaignsFiltersProps {
  filters: ISubcampaignsFilters
}
